import React from 'react';
import Money from '../../../../components/Money';

// eslint-disable-next-line react/prop-types
const Totals = ({ total, tip }) => (
  <div>
    <div className="u-flex u-justify-content-space-between u-align-end">
      <div className="u-text-large u-fw-bold u-co-grey u-hide-on-mobile u-mt-5">Total</div>
      <div className="u-text-large u-fw-bold u-co-grey u-mt-1 u-hide-on-desktop">Total</div>
      <div
        className="u-text-huge u-ta-right c-receipt-total--light"
      >
        <Money noDecimalsIfInt>{total}</Money>
      </div>
    </div>
    <div className="c-divider u-mt-4 u-mb-4" />
    <div className="u-flex u-justify-content-space-between u-align-center u-mb-2">
      <div className="u-text-normal u-co-grey">
        Subtotal
      </div>
      <div className="u-text-normal">
        <Money noDecimalsIfInt>{total - tip}</Money>
      </div>
    </div>
    {
      !!tip && (
        <div className="u-flex u-justify-content-space-between u-align-center u-mb-2">
          <div className="u-text-normal u-co-grey u-flex u-align-center">
            Tip
            <img
              width="16px"
              className="u-ml-1"
              src="https://squire-emails.s3-us-west-1.amazonaws.com/images/star.png"
              alt=""
            />
          </div>
          <div className="u-text-normal u-co-green">
            <Money noDecimalsIfInt>{tip}</Money>
          </div>
        </div>
      )
    }
  </div>
);

export default Totals;



// WEBPACK FOOTER //
// ./src/app/notifications/barber/BarberNewAppointment/components/Totals.jsx